import { MODELS, MODEL_INITIAL_VALUES } from '../../constants/admin/settings';
import { ADMIN_FORMS } from '../../constants/actions';
import { LOCATION_CHANGE } from 'react-router-redux';
import { filter, get } from 'lodash';
import { set } from 'dot-prop-immutable';

const initialState = {
    errors: {},
    fetching: false,
    fetched: false,
    submitting: false,
    fetchingDependencies: false,
    fetchedDependencies: false,
    dependencies: {},
    edited: false,
    [MODELS.CONTACT]: MODEL_INITIAL_VALUES[MODELS.CONTACT],
    [MODELS.EVENT]: MODEL_INITIAL_VALUES[MODELS.EVENT],
    [MODELS.ARTIST_CONTACTS]: MODEL_INITIAL_VALUES[MODELS.ARTIST_CONTACTS],
    [MODELS.ORGANIZATION]: MODEL_INITIAL_VALUES[MODELS.ORGANIZATION],
    [MODELS.PARTNER]: MODEL_INITIAL_VALUES[MODELS.PARTNER],
    [MODELS.ARTIST]: MODEL_INITIAL_VALUES[MODELS.ARTIST],
    [MODELS.CONTRACT]: MODEL_INITIAL_VALUES[MODELS.CONTRACT],
    [MODELS.TEMPLATE]: MODEL_INITIAL_VALUES[MODELS.TEMPLATE],
    [MODELS.ENTRY]: MODEL_INITIAL_VALUES[MODELS.ENTRY],
    [MODELS.EVENT_EMAIL]: MODEL_INITIAL_VALUES[MODELS.EVENT_EMAIL]
};

function reducer(state = initialState, action) {
    switch (action.type) {
        case ADMIN_FORMS.SET:
            return set(state, action.field, action.value);
        case ADMIN_FORMS.RESET:
            return { ...state, [action.model]: initialState[action.model], errors: {} };
        case ADMIN_FORMS.INPUT:
            return {
                ...state,
                edited: !action.silence,
                [action.model]: { ...state[action.model], [action.field]: action.value }
            };
        case ADMIN_FORMS.INPUT_KEY_VALUE:
            const changed = state[action.model][action.field][action.index];
            const keyValues = [
                ...state[action.model][action.field].slice(0, action.index),
                {
                    k: action.subField === 'k' ? action.value : changed.k,
                    v: action.subField === 'v' ? action.value : changed.v
                },
                ...state[action.model][action.field].slice(action.index + 1)
            ];
            const hasEmpty = filter(keyValues, kv => !kv.v).length;
            return {
                ...state,
                edited: true,
                [action.model]: {
                    ...state[action.model],
                    [action.field]: hasEmpty
                        ? keyValues
                        : keyValues.concat(initialState[MODELS.CONTACT][action.field][0])
                }
            };
        case ADMIN_FORMS.DELETE_KEY_VALUE:
            return {
                ...state,
                edited: true,
                [action.model]: {
                    ...state[action.model],
                    [action.field]: [
                        ...state[action.model][action.field].slice(0, action.index),
                        ...state[action.model][action.field].slice(action.index + 1)
                    ]
                }
            };
        case ADMIN_FORMS.SUBMIT:
            return { ...state, submitting: true };
        case ADMIN_FORMS.FETCH_START:
            return {
                ...state,
                [`fetching${action.dependencies ? `${action.sub ? 'Sub' : ''}Dependencies` : ''}`]: true
            };
        case ADMIN_FORMS.FETCH_OK:
            return {
                ...state,
                [`fetching${action.dependencies ? `${action.sub ? 'Sub' : ''}Dependencies` : ''}`]: false,
                [`fetched${action.dependencies ? `${action.sub ? 'Sub' : ''}Dependencies` : ''}`]: true,
                [action.model]: action.append ? { ...state[action.model], ...action.data } : action.data
            };
        case ADMIN_FORMS.FAILED:
            return { ...state, submitting: false, errors: action.errors };
        case ADMIN_FORMS.SUCCESS:
            return { ...state, submitting: false, errors: {} };
        case ADMIN_FORMS.REFRESH:
            return { ...state, fetched: false, errors: {} };
        case LOCATION_CHANGE:
            if (
                get(action, 'payload.pathname') === `/admin/contracts/${state[MODELS.CONTRACT].id}` ||
                get(action, 'payload.pathname') === `/admin/contracts/templates/${state[MODELS.TEMPLATE].id}` ||
                get(action, 'payload.pathname').includes(`/templates/new`)
            ) {
                return state;
            }
            return initialState;
        default:
            return state;
    }
}

export default reducer;
